module.exports = __webpack_public_path__ + "img/Practical Fixer.8a2cca35.svg";